/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterView } from "vue-router";
import { LoginFormComponent, Navbar } from "@app/vue/components/index";
import { useAuth } from "@app/vue/providers/index";

export const Layout = defineComponent({
  name: "Layout",
  setup() {
    const { user, setUser } = useAuth();
    return () => (
      <div class="h-screen flex flex-col flex-1">
        <RouterView />
      </div>
    );
  },
});
